export default __webpack_public_path__ + "static/media/3.07727c9d.png";